module.exports = __webpack_public_path__ + "media/images/oficinas/mburucuya-4138769ca7ff8f003f699bbc9b19371e.jpg";